import React from 'react'

const errorBoundaryWrapper = (ErrorHandler, OriginalComponent) => {
    return (props) => <ErrorHandler><OriginalComponent {...props} /></ErrorHandler>
}

export default errorBoundaryWrapper
